import { render } from "./ModalItemDescriptionChanged.vue?vue&type=template&id=1e6701bc&ts=true"
import script from "./ModalItemDescriptionChanged.vue?vue&type=script&lang=ts"
export * from "./ModalItemDescriptionChanged.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__